<template>
  <div class="preloader" :class="{ 'd-none': skip }">
    <div class="underlay"></div>
    <div class="circle">
      <svg class="outline gray" viewBox="0 0 200 200" width="100%" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="100" r="100"/>
      </svg>
      <svg class="outline black" viewBox="0 0 200 200" width="100%" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="100" r="100"/>
      </svg>
      <p class="year">
        <span>2</span><span>0</span><span class="switcher to-50"><span>1<br></span><span>0</span></span>
        <span class="switcher to-90"><span>8<br>7<br>6<br>5<br>4<br>3<br>2<br>1<br>0<br>9<br>8<br></span><span>7</span></span>
      </p>
    </div>
    <p class="loading">
      <span>L</span><span>o</span><span>a</span><span>d</span><span>i</span><span>n</span><span>g</span><span>.</span><span>.</span><span>.</span>
    </p>
  </div>
</template>

<script>
  import { TimelineMax, Expo } from 'TweenMax'
  import { Bus } from '@/lib/consts'

  export default {
    name: 'Preloader',
    data () {
      return {
        skip: process.env.USR === 'luke'
      }
    },
    methods: {
      finish () {
        this.$store.dispatch( 'setPreloader', false )
        Bus.$emit( 'preloadFinished' )
      },
      tween () {
        let tl = new TimelineMax( { onComplete: this.finish } )

        tl.staggerFromTo( '.loading span', 0.6, { y: -15, opacity: 0 }, { y: 0, opacity: 1, ease: Expo.easeInOut }, 0.1 )
        tl.staggerFromTo( '.year span', 0.6, { y: 37 }, { y: 0, ease: Expo.easeInOut }, 0.1, '-=1', null )
        tl.to( '.switcher span', 0, { opacity: 1 } )
        tl.fromTo( '.outline.gray', 0.8, { scale: 0.92, opacity: 0 }, { scale: 1, opacity: 1, ease: Expo.easeInOut }, '-=.7' )
        tl.fromTo( '.outline.black', 2.5, { strokeDashoffset: 650 }, { strokeDashoffset: 0, ease: Expo.easeInOut } )
        tl.to( '.switcher.to-50', 1.5, { y: '50%', ease: Expo.easeInOut }, '-=2.1' )
        tl.to( '.switcher.to-90', 1.5, { y: '91.6%', ease: Expo.easeInOut }, '-=2.1' )
        tl.to( '.circle, .loading', 0.7, { opacity: 0, scale: 0.9, ease: Expo.easeInOut }, '-=0.5' )
        tl.to( '.underlay', 1.25, { y: '100%', ease: Expo.easeInOut }, '-=.4' )
        tl.call( () => Bus.$emit( 'tweenTitles' ), null, null, '-=.85' )
      }
    },
    mounted () {
      if ( this.skip ) {
        Bus.$emit( 'tweenTitles' )
        this.finish()
      } else {
        this.tween()
      }
    }
  }
</script>

<style lang="scss">
  @import "~@/assets/scss/global/the_goods";

  .preloader {
    position        : fixed;
    top             : 0;
    left            : 0;
    width           : 100%;
    height          : 100%;
    z-index         : 102;
    display         : flex;
    justify-content : center;
    align-items     : center;
    flex-direction  : column;

    .underlay {
      position   : absolute;
      top        : 0;
      left       : 0;
      width      : 100%;
      height     : 100%;
      background : white;
    }

    .circle {
      width           : 200px;
      height          : 200px;
      display         : flex;
      justify-content : center;
      align-items     : center;
      position        : relative;

      .outline {
        z-index      : 10;
        fill         : none;
        stroke-width : 2px;
        position     : absolute;
        top          : 0px;
        left         : 0px;

        &.gray {
          fill         : none;
          stroke       : #e8e8e8;
          stroke-width : 2px;
          position     : absolute;
        }

        &.black {
          transform        : rotate(-90deg);
          stroke           : #656565;
          stroke-dasharray : 650;
        }
      }

      .year {
        text-align      : center;
        font-family     : $knockout-50;
        font-style      : normal;
        font-size       : rem(40);
        line-height     : 1em;
        overflow        : hidden;
        height          : 1em;
        display         : flex;
        justify-content : center;
        align-items     : flex-end;

        span {
          display : inline-block;

          span {
            display : inline;
          }

          &.switcher {

            span {
              opacity : 0;

              &:last-child {
                opacity : 1;
              }
            }
          }
        }
      }
    }

    .loading {
      text-align  : center;
      font-family : $adobe-clean-serif;
      font-size   : rem(15);
      font-style  : italic;

      span {
        display : inline-block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Preloader.vue